/**
 * Favorite DTO for use with {@link FavoritesService}
 * @property {string} sku - product SKU
 * @property {number} availableQuantity - available purchase quantity of this item
 * @property {number} backOrderAvailableDate - back-order availability date; null if not on back-order
 * @property {string} market - market
 */
class Favorite {
    constructor(data = {}) {
        this.sku = data.sku || '';
        this.availableQuantity = data.availableQuantity || 0;
        this.backOrderAvailableDate = data.backOrderAvailableDate || null;
        this.market = data.market || null;
        Object.freeze(this);
    }
}

export default Favorite;
